import { configureRuntimeApplicationForApp, getRuntimeInstallerBindingContext, installRuntimeDrawContributionsToApp, installRuntimeGraphicRenderersToApp, refreshRuntimeInstallerContributions } from "@visactor/vrender-core/entries/runtime-installer";

import { registerArc3dGraphic, registerArcGraphic, registerAreaGraphic, registerCircleGraphic, registerGlyphGraphic, registerGroupGraphic, registerImageGraphic, registerLineGraphic, registerPathGraphic, registerPolygonGraphic, registerPyramid3dGraphic, registerRect3dGraphic, registerRectGraphic, registerRichtextGraphic, registerShadowRootGraphic, registerStarGraphic, registerSymbolGraphic, registerTextGraphic, registerWrapTextGraphic } from "@visactor/vrender-core/register/graphic";

import { arc3dModule, arcModule, areaModule, circleModule, glyphModule, imageModule, lineModule, pathModule, polygonModule, pyramid3dModule, rect3dModule, rectModule, richtextModule, starModule, symbolModule, textModule } from "@visactor/vrender-core/graphic/modules";

const standardGraphicInstallSteps = [ {
    register: registerArcGraphic,
    bindModule: arcModule
}, {
    register: registerArc3dGraphic,
    bindModule: arc3dModule
}, {
    register: registerAreaGraphic,
    bindModule: areaModule
}, {
    register: registerCircleGraphic,
    bindModule: circleModule
}, {
    register: registerGlyphGraphic,
    bindModule: glyphModule
}, {
    register: registerGroupGraphic
}, {
    register: registerImageGraphic,
    bindModule: imageModule
}, {
    register: registerLineGraphic,
    bindModule: lineModule
}, {
    register: registerPathGraphic,
    bindModule: pathModule
}, {
    register: registerPolygonGraphic,
    bindModule: polygonModule
}, {
    register: registerPyramid3dGraphic,
    bindModule: pyramid3dModule
}, {
    register: registerRectGraphic,
    bindModule: rectModule
}, {
    register: registerRect3dGraphic,
    bindModule: rect3dModule
}, {
    register: registerRichtextGraphic,
    bindModule: richtextModule
}, {
    register: registerShadowRootGraphic
}, {
    register: registerStarGraphic,
    bindModule: starModule
}, {
    register: registerSymbolGraphic,
    bindModule: symbolModule
}, {
    register: registerTextGraphic,
    bindModule: textModule
}, {
    register: registerWrapTextGraphic
} ];

let standardGraphicsInstalled = !1;

function ensureStandardGraphicsInstalled() {
    if (standardGraphicsInstalled) return;
    const bindingContext = getRuntimeInstallerBindingContext();
    standardGraphicsInstalled = !0, standardGraphicInstallSteps.forEach((({register: register, bindModule: bindModule}) => {
        register(), null == bindModule || bindModule({
            bind: bindingContext.bind
        });
    })), refreshRuntimeInstallerContributions();
}

export function installStandardGraphicsToApp(app) {
    configureRuntimeApplicationForApp(app), ensureStandardGraphicsInstalled(), installRuntimeDrawContributionsToApp(app), 
    installRuntimeGraphicRenderersToApp(app);
}
//# sourceMappingURL=graphics.js.map